import React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import * as PXBColors from '@brightlayer-ui/colors';
import { xAxisScaleValue } from '../../constants/index';
export const PhaseResolvedGraphData: React.FC<{
    value: any;
    scaleValue: number;
    pdConversions: any; 
}> = (props) => {
    const chartRef = React.useRef<{
        chart: Highcharts.Chart;
        container: React.RefObject<HTMLDivElement>;
    }>(null);
    let tickInterval, max, min;
    xAxisScaleValue.map((itm) => {
        if (props.scaleValue === itm.value) {
            tickInterval = itm.tickInterval;
            max = itm.max;
            min = itm.min;
        }
        return true;
    });
    const PRGraphValue: any = [];
    props.value.value.chartData.map((i: any) =>
        PRGraphValue.push([parseFloat(i.xAxis), parseFloat(i.yAxis), parseFloat(i.value)])
    );
    /* eslint-disable */
    const roundNearest10 = (num: any) => {
        return Math.ceil(num / 20) * 20;
    };

    const roundNearest50to100 = (num: any) => {
        return Math.ceil(num / 100) * 100;
    };

    const roundNearest02 = (num: any) => {
        return Math.ceil(num / 0.2) * 0.2;
    };

    const RoundNearest05 = (num: any) => {
        return Math.ceil(num / 0.5) * 0.5;
    };

    const dataList = PRGraphValue;
    const maxValue: any = [];
    if (props.pdConversions === 'Magn,mV') {
        if (props.scaleValue !== 0) {
            xAxisScaleValue.map((item) => {
                if (props.scaleValue === item.value) {
                    tickInterval = item.tickInterval;
                    max = item.max;
                    min = item.min;
                }
                return true;
            });
        } else {
            dataList.forEach((element: any) => {
                if (element[2] !== 0) {
                    maxValue.push(element[0]);
                }

                const maximumMV = Math.max.apply(Math, maxValue);

                if (maximumMV >= 0.01 && maximumMV <= 100) {
                    const valueMV001: any = roundNearest10(maximumMV);
                    tickInterval = valueMV001 / 2;
                    max = valueMV001;
                    min = 0;
                } else if (maximumMV >= 100) {
                    const valueMV100: any = roundNearest50to100(maximumMV);
                    tickInterval = valueMV100 / 2;
                    max = valueMV100;
                    min = 0;
                }
            });
        }
    }

    if (props.pdConversions === 'Charge,nC') {
        if (props.scaleValue !== 0) {
            xAxisScaleValue.map((item) => {
                if (props.scaleValue === item.value) {
                    tickInterval = item.tickInterval;
                    max = item.max;
                    min = item.min;
                }
                return true;
            });
        } else {
            dataList.forEach((element: any) => {
                if (element[2] !== 0) {
                    maxValue.push(element[0]);
                }

                const maximumNC = Math.max.apply(Math, maxValue);
                if (maximumNC >= 0.01 && maximumNC <= 5) {
                    const nC001: any = roundNearest02(maximumNC);
                    tickInterval = nC001 / 2;
                    max = nC001;
                    min = 0;
                }
                if (maximumNC >= 5) {
                    const nC05: any = RoundNearest05(maximumNC);
                    tickInterval = nC05 / 2;
                    max = nC05;
                    min = 0;
                }
            });
        }
    }

    const seriesData: any = [];
    dataList.map((items: any) => {
        if (items[2] !== 0) {
            if (items[2] >= '0' && items[2] <= '0.425') {
                seriesData.push({
                    type: 'scatter',
                    showInLegend: false,
                    name: items[2],
                    color: PXBColors.black[500],
                    zIndex: 0,
                    data: [
                        {
                            x: items[0],
                            y: items[1],
                        },
                    ],
                    marker: {
                        symbol: 'circle',
                    },
                });
            }
            if (items[2] > '0.875' && items[2] <= '1.3') {
                seriesData.push({
                    type: 'scatter',
                    showInLegend: false,
                    color: '#00ffff',
                    name: items[2],
                    zIndex: 2,
                    data: [
                        {
                            x: items[0],
                            y: items[1],
                        },
                    ],
                    marker: {
                        symbol: 'circle',
                    },
                });
            }
            if (items[2] > '2.5' && items[2] <= '6.25') {
                seriesData.push({
                    type: 'scatter',
                    showInLegend: false,
                    color: PXBColors.red[500],
                    name: items[2],
                    zIndex: 2,
                    data: [
                        {
                            x: items[0],
                            y: items[1],
                        },
                    ],
                    marker: {
                        symbol: 'circle',
                    },
                });
            }

            if (items[2] > '0.425' && items[2] <= '0.875') {
                seriesData.push({
                    type: 'scatter',
                    showInLegend: false,
                    color: PXBColors.lightBlue[500],
                    name: items[2],
                    zIndex: 2,
                    data: [
                        {
                            x: items[0],
                            y: items[1],
                        },
                    ],
                    marker: {
                        symbol: 'circle',
                    },
                });
            }
            if (items[2] > '1.3' && items[2] <= '2.5') {
                seriesData.push({
                    type: 'scatter',
                    showInLegend: false,
                    color: PXBColors.purple[500],
                    name: items[2],
                    zIndex: 2,
                    data: [
                        {
                            x: items[0],
                            y: items[1],
                        },
                    ],
                    marker: {
                        symbol: 'circle',
                    },
                });
            }

            if (items[2] >= '6.5') {
                seriesData.push({
                    type: 'scatter',
                    showInLegend: false,
                    color: '#ffff00',
                    name: items[2],
                    zIndex: 2,
                    data: [
                        {
                            x: items[0],
                            y: items[1],
                        },
                    ],
                    marker: {
                        symbol: 'circle',
                    },
                });
            }
        }
        return true;
    });

    const highchartsConfig = {
        chart: {
            height: 220,
        },

        plotOptions: {
            scatter: {
                marker: {
                    radius: 5,
                    states: {
                        hover: {
                            enabled: false,
                            lineColor: 'rgb(100,100,100)',
                            colorByPoint: true,
                        },
                    },
                },
            },
        },
        states: {
            hover: {
                marker: {
                    enabled: false,
                },
            },
        },

        exporting: {
            enabled: false,
        },

        xAxis: {
            title: false,
            tickInterval: tickInterval,
            max: max,
            min: min,
            lineColor: '#141414',
            labels: {
                style: {
                    color: '#141414',
                },
            },
        },
        yAxis: {
            maxPadding: 0.2,
            title: false,
            tickInterval: 90,
            min: 0,
            max: 360,
            lineColor: '#141414',

            labels: {
                style: {
                    color: '#141414',
                },
            },
        },

        tooltip: {
            borderRadius: 10,
            borderWidth: 3,
        },

        series: seriesData,
        subtitle: {
            text: '',
        },
        legend: {
            layout: 'horizontal',
            align: 'left',
            verticalAlign: 'bottom',
        },
        title: {
            text: '',
            align: 'left',
        },
        credits: {
            enabled: false,
        },
    };

    return (
        <div data-testid="device-info-PhaseResolvedChart">
            <HighchartsReact              
                ref={chartRef}
                highcharts={Highcharts}
                options={highchartsConfig}
            ></HighchartsReact>
        </div>
    );
};
